import React from 'react';

import styles from '../styles/Loading.module.scss';

function Loading() {
  return (
    <figure className={ styles.loading }>
      <div />
      <div />
      <div />
      <div />
    </figure>
  );
}

export default Loading;
